module.exports = __webpack_public_path__ + "img/ch41.c6d211c1.png";